import ErrorLogger from './ErrorLogger';

ErrorLogger.createFromGlobals()?.processErrorQueue();
